import {Fee} from './Fee';

export class StartFeeData {
  category: string;
  fee: Fee[] = [];
}
